import React, { Component } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Topbar from "../components/TopbarGarnet";
import FooterGarnet from "../components/FooterGarnet";
import Typography from '@material-ui/core/Typography';

const fondoImagenUrl = require("../images/back-bike.jpg");
const iconoCentral = require("../images/icono_central.png");

const styles = theme => ({
    tituloPrincipal1: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "48px",
        lineHeight: "53px",
        color: "#f6bc50",
        marginBottom: "1rem"
    },
    tituloPrincipal2: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "32px",
        lineHeight: "1",
        color: "#f6bc50",
        marginBottom: "3rem"
    },
    textoDetalle: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "24px",
        lineHeight: "26px",
        color: "#474747",
        marginBottom: "1.5rem"
    },
    iconoCentral: {
        width: '200px',
        marginLeft: '-100px',
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    fondoImagen: {
        background: `url(${fondoImagenUrl}) no-repeat`,
        backgroundSize: "cover",
        height: '960px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down("sm")]: {
            height: "100vh",
            display: "block",
            position: "fixed",
            top: 0,
            width: "100%",
            backgroundPosition: "center",
        }
    },
    containerTab: {
        padding: "10px 7rem 10px 5rem", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: "10px 1rem 10px 1rem", 
          padding: "10px 1rem 10px 1rem", 
            padding: "10px 1rem 10px 1rem", 
            height: "initial",
            overflow: "initial",
            overflowX: "initial",
            backgroundColor: "rgba(255,255,255,1)",
            position: "relative",
            zIndex: "1",
            minHeight: "calc(100vh - 160px)",
        }
    }
})
const queryString = require('query-string');
class LandingExito extends Component{
    constructor(props){
        super(props);
        this.state = {
            plan: '',
            currentPath: window.location.hash.split('/')[1] == '' ||  window.location.hash.split('/')[1].includes("landing") ? 'garnetek' : window.location.hash.split('/')[1],
        }
    }
    toRetry(){

    }
    componentDidMount(){
        
        var parsed = queryString.parse(this.props.location.search);
        this.setState({plan: parsed.plan ? parsed.plan : ''});
        console.log(document.querySelector('.mp-mercadopago-checkout-wrapper'));
        if(document.querySelector('.mp-mercadopago-checkout-wrapper')){
            while(document.querySelector('.mp-mercadopago-checkout-wrapper')){
                document.querySelector('.mp-mercadopago-checkout-wrapper').remove();
            }
        }
    }
    currentMainColor(){
        if (this.state.currentPath == "cuq") {
            return "#15669D";
        }
        else if (this.state.currentPath == "h2o") {
            return "#f6bc50";
        }
        else if (this.state.currentPath == "bicisport") {
            return "#333333";  
        }
        else {
            return "#f6bc50";
        }
    }
    currentIconoCentral(){
        if (this.state.currentPath == "cuq") {
            return require("../images/icono_central_cuq.png");
        }
        else if (this.state.currentPath == "h2o") {
            return iconoCentral;
        }
        else if (this.state.currentPath == "bicisport") {
            return require("../images/icono_central_black.png");
        }
        else {
            return iconoCentral;
        }
    }
    render(){
        const { classes } = this.props;
        return (
            <>
                <Topbar currentPath = {this.state.currentPath} />
                    <Grid container spacing={0}>
                        <Grid  item xs={12} sm={12} md={6}>
                            <div className={classes.containerTab}>
                                <Typography style={{marginTop: "2rem", color: this.currentMainColor()}} className={classes.tituloPrincipal1}>
                                    Compra exitosa!
                                </Typography>
                                <Typography className={classes.tituloPrincipal2} style={{ color: this.currentMainColor() }} >
                                Gracias por asegurar tu bici con nosotros
                                </Typography>
                                <Typography  className={classes.textoDetalle} style={{ color: this.currentMainColor() }}>
                                    Estamos analizando los antecedentes y en 48 hrs o antes enviaremos tu póliza.
                                    <br></br>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid className={classes.fondoImagen } item xs={12} sm={12} md={6}>
                            <img className={classes.iconoCentral} src={this.currentIconoCentral()}  alt="icono"></img>
                        </Grid>
                    </Grid>
                <FooterGarnet />
            </>
        );
    }
}

export default withRouter(withStyles(styles)(LandingExito));
